import React, { useState, useEffect } from "react";
import ActionButtons from "../preapps/ActionButtons";
import PreapChildRow from "./child-row/child-row";
import PreapChildRowDefault from "./child-row/child-row-default";
import SalesPreappStatusBar from "./status-bar/sales-preapp-status-bar";
import SalesPreappStatusBarParent from "./status-bar/sales-preapp-status-bar-parent";
import PreappStatusBar from "./status-bar/status-bar";
import CustomCheckBox from "./checkbox";

import PreappStatusBarParent from "./status-bar/status-bar-parent";
import moment from "moment";
const PreappArow = ({
    appInfoContent,
    activeId,
    user,
    row_info,
    defaultBank,
    default_index,
    pci_admin,
    t,
    status2Percentage,
    handleClick,
    currentStatus,
    handleStar,
    handleCancle,
    handlePdfRun,
    handleAppCopy,
    handleChangeOwner,
    showBanks,
    handleActiveBank,
    check,
    status2PercentageFn,
    handleClickWithChild,
    handleChildAppClick,
    show_info,
    currentProgressName,
    handleChangeBank,
    isMobile,
    showExpandedInfo,
    handleClickForMobileView,
    hidden_app_user_id,
    updateBulkDataArray,
}) => {
    const [showButtons, setShowButtons] = useState(false);
    const [pciAdmin, setPCIAdmin] = useState(false);
    const [rowExpanded, setRowExpanded] = useState(false);
    const [clicks, setClicks] = useState(0);
    const [singleClickTimeout, setSingleClickTimeout] = useState(null);

    useEffect(() => {
        setPCIAdmin(pci_admin);
    });

    const handleShowButtons = () => {
        setShowButtons(true);
    };

    const handleHideButtons = () => {
        setShowButtons(false);
    };
    const bindClassName = (data) => {
        if (data.child && data.child.length > 0) {
            return "has-child";
        } else {
            return "";
        }
    };

    const handleClicks = () => {
        if (isMobile) {
            setClicks((prev) => prev + 1);
        } else {
            handleClick(t[1].id, t[0]);
        }
    };

    const handleDoubleClick = () => {
        if (isMobile) {
            clearTimeout(singleClickTimeout);
            setClicks(0);
            handleClickForMobileView(t[1].id, t[0], false);
        }
    };

    useEffect(() => {
        if (isMobile) {
            if (clicks === 1) {
                const timer = setTimeout(() => {
                    if (!rowExpanded) {
                        handleClickForMobileView(t[1].id, t[0], true);
                    }
                    setRowExpanded((prev) => !prev);
                    setClicks(0);
                }, 250); // 250 milliseconds delay to distinguish single click from double click
                setSingleClickTimeout(timer);
            } else if (clicks === 2) {
                handleDoubleClick();
            }
        }

        return () => clearTimeout(singleClickTimeout);
    }, [clicks]);

    const showChild = (data) => {
        if ((row_info && activeId === t[1].id) || getChildIndex(t[1])) {
            return "show";
        } else {
            return "";
        }
    };

    const getChildIndex = (parent) => {
        if (parent.child.length > 0) {
            const inChildAcive = parent.child.find((x) => x.id === activeId);
            if (inChildAcive) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    return (
        <>
            <div
                className={
                    (check.includes("" + t[1].id + "") ||
                    activeId === t[1].id ||
                    getChildIndex(t[1])
                        ? "table-div-tr active checkbox-overflow-initial"
                        : "table-div-tr checkbox-overflow-initial") +
                    " " +
                    bindClassName(t[1]) +
                    " " +
                    showChild(t[1])
                }
                key={t[0]}
            >
                {t[1].child && t[1].child.length <= 0 ? (
                    <>
                        <div
                            className="application_rows"
                            onMouseLeave={() => {
                                handleHideButtons();
                            }}
                            onMouseEnter={() => {
                                handleShowButtons();
                            }}
                        >
                            {(user?.organization_id == 1) && (
                                <CustomCheckBox
                                    name={`check-btn`}
                                    value={t[1].id}
                                    onChange={(e) => {
                                        updateBulkDataArray(
                                            t[1].id,
                                            e.target.checked,
                                        );
                                    }}
                                />
                            )}
                            <div
                                className={`table-div-tr-inner`}
                                onClick={(e) => handleClick(t[1].id, t[0])}
                            >
                                {isMobile ? (
                                    <>
                                        {!showButtons &&
                                            (t[1]?.user?.channel == "sales_channel"
                                                || t[1]?.user?.channel == "partner_channel" ? (
                                                <SalesPreappStatusBar
                                                    status2Percentage={
                                                        status2Percentage
                                                    }
                                                    currentStatus={currentProgressName(
                                                        t[1]
                                                            .lead_progression_id,
                                                    )}
                                                    t={t}
                                                />
                                            ) : (
                                                <PreappStatusBar
                                                    status2Percentage={
                                                        status2Percentage
                                                    }
                                                    currentStatus={
                                                        currentStatus
                                                    }
                                                    t={t}
                                                />
                                            ))}

                                        {showButtons &&
                                            (t[1]?.user?.channel ==
                                            "sales_channel" || t[1]?.user?.channel ==
                                            "partner_channel" ? (
                                                <SalesPreappStatusBar
                                                    status2Percentage={
                                                        status2Percentage
                                                    }
                                                    currentStatus={currentProgressName(
                                                        t[1]
                                                            .lead_progression_id,
                                                    )}
                                                    t={t}
                                                />
                                            ) : (
                                                <PreappStatusBar
                                                    status2Percentage={
                                                        status2Percentage
                                                    }
                                                    currentStatus={
                                                        currentStatus
                                                    }
                                                    t={t}
                                                />
                                            ))}

                                        <div
                                            className={
                                                user.role !== "agent"
                                                    ? "table-div-td col-merchant-dba"
                                                    : "table-div-td col-merchant-dba dba-name-agent"
                                            }
                                        >
                                            <span
                                                title={
                                                    t[1].field_dba || (
                                                        <>&mdash;</>
                                                    )
                                                }
                                            >
                                                {t[1].field_dba || <>&mdash;</>}
                                            </span>
                                        </div>
                                    </>
                                ) : (
                                        <>
                                        {!showButtons &&
                                                (t[1]?.user?.channel ==
                                                "sales_channel"
                                                || t[1]?.user?.channel ==
                                                "partner_channel" ? (
                                                <SalesPreappStatusBar
                                                    status2Percentage={
                                                        status2Percentage
                                                    }
                                                    currentStatus={currentProgressName(
                                                        t[1]
                                                            .lead_progression_id,
                                                    )}
                                                    t={t}
                                                />
                                            ) : (
                                                <PreappStatusBar
                                                    status2Percentage={
                                                        status2Percentage
                                                    }
                                                    currentStatus={
                                                        currentStatus
                                                    }
                                                    t={t}
                                                />
                                            ))}
                                        {!showButtons && (
                                            <div className="table-div-td col-id">
                                                {t[1].id}
                                                <i className="fa fa-chevron-down"></i>
                                            </div>
                                            )}

                                        {showButtons &&
                                                (t[1]?.user?.channel ==
                                                "sales_channel"
                                                || t[1]?.user?.channel ==
                                                "partner_channel" ? (
                                                <SalesPreappStatusBar
                                                    status2Percentage={
                                                        status2Percentage
                                                    }
                                                    currentStatus={currentProgressName(
                                                        t[1]
                                                            .lead_progression_id,
                                                    )}
                                                    t={t}
                                                />
                                            ) : (
                                                <PreappStatusBar
                                                    status2Percentage={
                                                        status2Percentage
                                                    }
                                                    currentStatus={
                                                        currentStatus
                                                    }
                                                    t={t}
                                                />
                                            ))}

                                        <div
                                            className={
                                                user.role !== "agent"
                                                    ? "table-div-td col-merchant-dba"
                                                    : "table-div-td col-merchant-dba dba-name-agent"
                                            }
                                        >
                                            <span
                                                title={
                                                    t[1].field_dba || (
                                                        <>&mdash;</>
                                                    )
                                                }
                                            >
                                                {t[1].field_dba || <>&mdash;</>}
                                            </span>
                                        </div>
                                        <div className="table-div-td col-bank">
                                            <span
                                                title={
                                                    t[1].organization != null
                                                        ? t[1].organization.name
                                                        : ""
                                                }
                                            >
                                                {t[1].organization &&
                                                t[1].organization.name ? (
                                                    t[1].organization.name.substring(
                                                        0,
                                                        20,
                                                    ) + "..."
                                                ) : (
                                                    <>&mdash;</>
                                                )}
                                            </span>
                                        </div>

                                        {user.role !== "agent" && (
                                            <div className="table-div-td col-agent child">
                                                {t[1].user != null
                                                    ? t[1].user.id
                                                    : ""}
                                            </div>
                                        )}

                                        <div className="table-div-td col-created-at">
                                            {t[1].child &&
                                            t[1].child.length > 0 ? (
                                                <ActionButtons
                                                    handleChangeBank={
                                                        handleChangeBank
                                                    }
                                                    user={user}
                                                    preapp={t[1]}
                                                    showButtons={showButtons}
                                                    onAssignBank={(
                                                        preapp,
                                                        childApp,
                                                    ) => {
                                                        showBanks(
                                                            preapp.id,
                                                            childApp,
                                                        );
                                                    }}
                                                    onCancel={(preapp) =>
                                                        handleCancle(preapp.id)
                                                    }
                                                    onReRun={(preapp) =>
                                                        handlePdfRun(preapp.id)
                                                    }
                                                    onCopy={(preapp) =>
                                                        handleAppCopy(preapp.id)
                                                    }
                                                    onChangeOwnership={() =>
                                                        handleChangeOwner()
                                                    }
                                                    nonBankClass={"no-add-bank"}
                                                />
                                            ) : (
                                                <ActionButtons
                                                    handleChangeBank={
                                                        handleChangeBank
                                                    }
                                                    pci_admin={pciAdmin}
                                                    user={user}
                                                    preapp={t[1]}
                                                    showButtons={showButtons}
                                                    showAssignBank={true}
                                                    showMerchantColumn={true}
                                                    onAssignBank={(
                                                        preapp,
                                                        childApp,
                                                    ) => {
                                                        showBanks(
                                                            preapp.id,
                                                            childApp,
                                                        );
                                                    }}
                                                    onCancel={(preapp) =>
                                                        handleCancle(preapp.id)
                                                    }
                                                    onReRun={(preapp) =>
                                                        handlePdfRun(preapp.id)
                                                    }
                                                    onCopy={(preapp) =>
                                                        handleAppCopy(preapp.id)
                                                    }
                                                    onChangeOwnership={() =>
                                                        handleChangeOwner()
                                                    }
                                                />
                                            )}
                                        </div>
                                        <div className="table-div-td col-approved child">
                                            {t[1].approved_at != null
                                                ? moment(
                                                      t[1].approved_at,
                                                  ).format("MMM D, YYYY")
                                                : ""}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="application_rows">
                        <div
                            className={`table-div-tr-inner`}
                            onClick={(e) => handleClickWithChild(t[1].id, t[0])}
                            onMouseLeave={() => {
                                handleHideButtons();
                            }}
                            onMouseEnter={() => {
                                handleShowButtons();
                            }}
                        >
                            {pciAdmin && (
                                <CustomCheckBox
                                    name={`check-btn`}
                                    value={t[1].id}
                                    onChange={(e) =>
                                        checkedPowerApp(e, t[1].id, t[0])
                                    }
                                />
                            )}
                            <div
                                className={`table-div-tr-inner w-100`}
                                onClick={(e) =>
                                    handleClickWithChild(t[1].id, t[0])
                                }
                                onMouseLeave={() => {
                                    handleHideButtons();
                                }}
                                onMouseEnter={() => {
                                    handleShowButtons();
                                }}
                            >
                                {showButtons && (
                                    <div className="table-div-td col-id  col-id-hover count">
                                        {t[1].child.length + 1}
                                        <i className="fa fa-chevron-down"></i>
                                    </div>
                                    )}

                                {!showButtons &&
                                        (t[1]?.user?.channel == "sales_channel" || t[1]?.user?.channel == "partner_channel" ? (
                                        <SalesPreappStatusBarParent
                                            status2Percentage={
                                                status2Percentage
                                            }
                                            currentStatus={currentProgressName(
                                                t[1].lead_progression_id,
                                            )}
                                            t={t}
                                        />
                                    ) : (
                                        <PreappStatusBarParent
                                            status2Percentage={
                                                status2Percentage
                                            }
                                            currentStatus={currentStatus}
                                            t={t}
                                        />
                                    ))}

                                {!showButtons && (
                                    <div className="table-div-td col-id count">
                                        {t[1].child.length + 1}
                                        <i className="fa fa-chevron-down"></i>
                                    </div>
                                    )}

                                {showButtons &&
                                        (t[1]?.user?.channel == "sales_channel" || t[1]?.user?.channel == "partner_channel" ? (
                                        <SalesPreappStatusBarParent
                                            status2Percentage={
                                                status2Percentage
                                            }
                                            currentStatus={currentProgressName(
                                                t[1].lead_progression_id,
                                            )}
                                            t={t}
                                        />
                                    ) : (
                                        <PreappStatusBarParent
                                            status2Percentage={
                                                status2Percentage
                                            }
                                            currentStatus={currentStatus}
                                            t={t}
                                        />
                                    ))}

                                <div
                                    className={
                                        user.role !== "agent"
                                            ? "table-div-td col-merchant-dba"
                                            : "table-div-td col-merchant-dba dba-name-agent"
                                    }
                                >
                                    <span
                                        title={t[1].field_dba || <>&mdash;</>}
                                    >
                                        {t[1].field_dba || <>&mdash;</>}
                                    </span>
                                </div>
                                <div className="table-div-td col-bank">
                                    <span
                                        title={
                                            t[1].organization != null
                                                ? t[1].organization.name
                                                : ""
                                        }
                                    >
                                        {t[1].organization &&
                                        t[1].organization.name ? (
                                            t[1].organization.name.substring(
                                                0,
                                                20,
                                            ) + "..."
                                        ) : (
                                            <>&mdash;</>
                                        )}
                                    </span>
                                </div>

                                {user.role !== "agent" && (
                                    <div className="table-div-td col-agent child">
                                        {t[1].user != null ? t[1].user.id : ""}
                                    </div>
                                )}

                                <div className="table-div-td col-created-at">
                                    {t[1].child && t[1].child.length > 0 ? (
                                        <ActionButtons
                                            handleChangeBank={handleChangeBank}
                                            pci_admin={pciAdmin}
                                            user={user}
                                            preapp={t[1]}
                                            showButtons={showButtons}
                                            showAssignBank={true}
                                            onAssignBank={(
                                                preapp,
                                                childApp,
                                            ) => {
                                                showBanks(preapp.id, childApp);
                                            }}
                                            onCancel={(preapp) =>
                                                handleCancle(preapp.id)
                                            }
                                            onReRun={(preapp) =>
                                                handlePdfRun(preapp.id)
                                            }
                                            onCopy={(preapp) =>
                                                handleAppCopy(preapp.id)
                                            }
                                            onChangeOwnership={() =>
                                                handleChangeOwner()
                                            }
                                            nonBankClass={"no-add-bank"}
                                        />
                                    ) : (
                                        <ActionButtons
                                            handleChangeBank={handleChangeBank}
                                            user={user}
                                            preapp={t[1]}
                                            showButtons={showButtons}
                                            showAssignBank={true}
                                            showMerchantColumn={true}
                                            onAssignBank={(
                                                preapp,
                                                childApp,
                                            ) => {
                                                showBanks(preapp.id, childApp);
                                            }}
                                            onCancel={(preapp) =>
                                                handleCancle(preapp.id)
                                            }
                                            onCopy={(preapp) =>
                                                handleAppCopy(preapp.id)
                                            }
                                            onChangeOwnership={() =>
                                                handleChangeOwner()
                                            }
                                            onReRun={(preapp) =>
                                                handlePdfRun(preapp.id)
                                            }
                                        />
                                    )}
                                </div>
                                <div className="table-div-td col-approved child">
                                    {t[1].approved_at != null
                                        ? moment(t[1].approved_at).format(
                                              "MMM D, YYYY",
                                          )
                                        : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {row_info && (activeId === t[1].id || getChildIndex(t[1])) && (
                    <>
                        <span className="separator" />
                        <PreapChildRowDefault
                            isMerchant={false}
                            show_info={show_info}
                            activeId={activeId}
                            handleClick={(id, data) =>
                                handleChildAppClick(id, data)
                            }
                            t={t}
                            user={user}
                            defaultBank={defaultBank}
                            status2Percentage={(e) => status2PercentageFn(e)}
                            showBanks={(e) => showBanks(e)}
                            handleCancle={(e) => handleCancle(e)}
                            handlePdfRun={(e) => handlePdfRun(e)}
                            handleAppCopy={(e) => handleAppCopy(e)}
                            handleChangeOwner={() => handleChangeOwner()}
                            currentProgressName={(e) => currentProgressName(e)}
                        />
                        {t[default_index].child &&
                            Object.entries(t[default_index].child).map(
                                (element, k) =>
                                    element[default_index]?.bank?.id !=
                                        defaultBank.id && (
                                        <>
                                            <span className="separator" />
                                            <PreapChildRow
                                                isMerchant={false}
                                                activeId={activeId}
                                                handleClick={(id, data) =>
                                                    handleChildAppClick(
                                                        id,
                                                        data,
                                                    )
                                                }
                                                t={t}
                                                user={user}
                                                element={element}
                                                default_index={default_index}
                                                handleActiveBank={(e) =>
                                                    handleActiveBank(e)
                                                }
                                                status2Percentage={(e) =>
                                                    status2PercentageFn(e)
                                                }
                                                showBanks={(e) => showBanks(e)}
                                                handleCancle={(e) =>
                                                    handleCancle(e)
                                                }
                                                handlePdfRun={(e) =>
                                                    handlePdfRun(e)
                                                }
                                                handleAppCopy={(e) =>
                                                    handleAppCopy(e)
                                                }
                                                handleChangeOwner={() =>
                                                    handleChangeOwner()
                                                }
                                                currentProgressName={(e) =>
                                                    currentProgressName(e)
                                                }
                                            />
                                        </>
                                    ),
                            )}
                    </>
                )}
                {isMobile && activeId === t[1].id && rowExpanded && (
                    <div className="app-info-expanded-view">
                        {appInfoContent}
                    </div>
                )}
            </div>
        </>
    );
};

export default PreappArow;
